import React, {useState, useEffect} from "react";
import classNames from "classnames";

//material-ui
import {withStyles} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import {lighten} from "@material-ui/core/styles/colorManipulator";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";

import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
  container: {
    marginBottom: 0
  },
  table: {
    minWidth: 650
  },
  head: {
    fontFamily: ['Rubik', 'sans-serif'].join(","),
    backgroundImage:
      "linear-gradient(to right, #020d39, #012e58, #134e75, #307190, #5394a9);",
    // fontWeight: "600"
  },
  head_cell: {
    fontFamily: ['Rubik', 'sans-serif'].join(","),
    color: "white",
    fontWeight: "600",
    fontSize: "1em"
  },
  cell: {
    fontWeight: "400",
    fontSize: "1em",
    fontFamily: ['Rubik', 'sans-serif'].join(",")
  }
});

//add cluster_id column if not present.
function modColumns(columns) {
  columns.map((a) => Object.assign({}, a));
  let match = false;
  for (let i = 0; i < columns.length - 1; i++) {
    if (columns[i].name === "cluster_id") {
      match = true;
    }
  }
  if (!match) {
    columns.unshift({name: "cluster_id", title: "Cluster ID"});
  }
  return columns;
}

export default function ClusterTable({columns, data, activeStep, getSelected}) {
  const classes = useStyles();
  let orig_columns = columns.map((a) => Object.assign({}, a));
  const col = modColumns(orig_columns);
  const colmns = col ? col : columns;
  const [selected, setSelected] = useState([]);

//equivalent to ComponentDidMount(). Mainly handles going from table 3 back to cluster table.
  useEffect(() => {
    if (activeStep === 1 && selected.length === 2) {
      getSelected([data[selected[0]], data[selected[1]]]);
    }
    if(activeStep !== 1){
      getSelected([])
    }
  }, [activeStep, getSelected, selected, data]);

  // adding styling to matching cluster backgrounds
  let colored_data;
  if (data) {
    colored_data = data.map((a) => Object.assign({}, a));
  }
  let cluster_colors = ["#8BD6D1", "#CD9CF6", "#FA9B5C", "#A9FAC5", "#C5DEF5"];
  let font_color = "#06313D";

  let i = 0;
  let cc = 0;

  while (colored_data[i + 2]) {
      //check for tripples
    if (
      colored_data[i].cluster_id === colored_data[i + 1].cluster_id &&
      colored_data[i].cluster_id === colored_data[i + 2].cluster_id
    ) {
      colored_data[i]["color"] = {background: cluster_colors[cc]};
      colored_data[i + 1]["color"] = {background: cluster_colors[cc]};
      colored_data[i + 2]["color"] = {background: cluster_colors[cc]};
      colored_data[i]["style"] = {color: font_color, fontWeight: 800};
      colored_data[i + 1]["style"] = {color: font_color, fontWeight: 800};
      colored_data[i + 2]["style"] = {color: font_color, fontWeight: 800};
      cc++;
      i += 3;
    }
    //check for pairs
    else if (colored_data[i].cluster_id === colored_data[i + 1].cluster_id) {
      colored_data[i]["color"] = {background: cluster_colors[cc]};
      colored_data[i + 1]["color"] = {background: cluster_colors[cc]};
      colored_data[i]["style"] = {color: font_color, fontWeight: 800};
      colored_data[i + 1]["style"] = {color: font_color, fontWeight: 800};
      cc++;
      i += 2;
    } else {
      i++;
    }
    // catching the last 2 idx that previous while couldn't
    if (colored_data.length - 4) {
      let cid = cluster_colors.length - 1;
      for (
        var end = colored_data.length - 1;
        end >= colored_data.length - 3;
        end--
      ) {
        if (
          colored_data[end].cluster_id === colored_data[end - 1].cluster_id &&
          colored_data[end].cluster_id === colored_data[end - 2].cluster_id
        ) {
          colored_data[end]["color"] = {background: cluster_colors[cid]};
          colored_data[end - 1]["color"] = {background: cluster_colors[cid]};
          colored_data[end - 2]["color"] = {background: cluster_colors[cid]};
          cid--;
        }
        if (colored_data[end].cluster_id === colored_data[end - 1].cluster_id) {
          colored_data[end]["color"] = {background: cluster_colors[cid]};
          colored_data[end - 1]["color"] = {background: cluster_colors[cid]};
          colored_data[end]["style"] = {color: font_color, fontWeight: 800};
          colored_data[end - 1]["style"] = {color: font_color, fontWeight: 800};
          cid--;
        }
      }
    }
  }

  // checks if checkbox is selected to render appropriately.
  const isSelected = (i) => {
    selected.indexOf(i) !== -1;
  };

  // adds and removes selected rows into selected array; if array.len = 2, pass to stepper state.
  const handleClick = (event, i) => {
    const selectedIndex = selected.indexOf(i);
    let newSelected = [];
    if (selectedIndex === -1 && selected.length > 1) {
      newSelected = newSelected.concat(selected.slice(selected));
    } else if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, i);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    if(newSelected.length < 2){
      getSelected([])
    }
    if (newSelected.length === 2) {
      //passes selected pair to stepper state
      getSelected([data[newSelected[0]], data[newSelected[1]]]);
    }
    setSelected(newSelected);
  };

  return (
    <TableContainer component={Paper} className={classes.container}>
      {activeStep === 1 && (
        <EnhancedTableToolbar numSelected={selected.length} />
      )}
      <Table className={classes.table} aria-label="cluster table">
        <TableHead className={classes.head}>
          <TableRow>
            {activeStep === 1 && (
              <TableCell
                key={"checkbox"}
                className={classes.head_cell}
                align="center"
              >
                Selection
              </TableCell>
            )}
            {colmns.map((column) => (
              <TableCell
                key={column.name}
                align="center"
                className={classes.head_cell}
              >
                {column.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {colored_data.map((row, i) => {
            const isItemSelected = isSelected(i);
            return (
              <TableRow
                style={(row.style, row.color)}
                hover
                onClick={(event) => handleClick(event, i)}
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                key={i}
                align="center"
                value={row}
                selected={isItemSelected}
              >
                {activeStep === 1 && (
                  <TableCell align="center">
                    <Checkbox checked={selected.indexOf(i) !== -1} />
                  </TableCell>
                )}
                {colmns.map((column, t) => (
                  <TableCell
                    className={classes.cell}
                    style={row.style}
                    align="center"
                    key={t}
                  >
                    {row[column.name]}{" "}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing(12)
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },
  spacer: {
    flex: "1 1 100%"
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: {
    flex: "0 0 auto"
  }
});

// Toolbar over the table indicating number of selections. 
let EnhancedTableToolbar = (props) => {
  const {numSelected, classes} = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color="inherit">{numSelected} selected</Typography>
        )}
      </div>
      <div className={classes.spacer} />
    </Toolbar>
  );
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);
